module.exports = __webpack_public_path__ + "static/media/transporters.e7288505.xlsx";